import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {AppIconComponent} from '@shared/components/app-icon';

export type HeaderMegamenuTop = {
  menu_label?: {
    label: string,
    path: string
    id?: string
  };
  isOpen?: boolean;
  dropdownItems?: {
    label: string;
    path: string;
    id?: string;
  }[];
  btn?: {
    label: string,
    path: string
  },
  info?: {
    label: string,
    icon: {src: string, alt: string, label: string}
  }
};
@Component({
  selector: 'app-header-megamenu-top',
  templateUrl: './header-megamenu-top.component.html',
  styleUrl: './header-megamenu-top.component.scss',
  standalone: true,
  imports: [RouterLink, AppIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMegamenuTopComponent {
  @Input() headerMegamenuTop: HeaderMegamenuTop;
  isOpen: boolean = false;
  megamenu: HeaderMegamenuTop[] = [
    {
      menu_label: {
        label: 'Contatti',
        path: '/contatti',
        id: "1"
      },
      isOpen: false,
      dropdownItems: [
        {
          label: "Hai acquistato una polizza con un volo tramite un nostro partner?",
          path: "/contatti",
          id: "1"
        },
        {
          label: "Hai bisogno di assistenza, informazioni sull’acquisto o sui prodotti?",
          path: "/contatti",
          id: "2"
        },
        {
          label: "Hai bisogno di richiedere un rimborso o informazioni su un sinistro?",
          path: "/contatti",
          id: "3"
        },
        {
          label: "Altro",
          path: "/contatti",
          id: "4"
        },
      ],
    },
    {
      menu_label: {
        label: 'Chi siamo',
        path: ''
      },
      isOpen: false,
      dropdownItems: [
        {
          label: "Azienda",
          path: "/chi-siamo/azienda",
          id: "1"
        },
      /*  {
          label: "Comunicazione",
          path: "/chi-siamo/brand",
          id: "1"
        },
        {
          label: "Network Fornitori",
          path: "/chi-siamo/network",
        },*/
        {
          label: "Sostenibilità",
          path: "/chi-siamo/sostenibilita",
          id: "1"
        },
         {
          label: "Lavora con noi",
          path: "/lavora-con-noi",
        },
        /*{
          label: "Top Employer",
          path: "/chi-siamo/brand/top-employer"
        }*/
      ],
    },
    /*{
      menu_label: {
        label: 'Partners',
        path: '/partners'
      },


    },*/
    {
      btn: {
        label: 'In caso di sinistro',
        path: 'https://sinistrionline.redion.it/'
      }

    },
    {
      info: {
        label: 'Info e Assistenza',
        icon: {src: '../../../../../../../assets/img/phone_assistenza.svg' , alt: 'Phone', label: '803.803'}
      },
      isOpen: false

    }

  ];
  /**
   * @param {string} url
   * @return {*}
   * @memberof HeaderComponent
   */
  navigateByUrl( url: string ) {
    if ( url && url.length > 0 ) {
      return window.open( url );
    }
    return null;
  }
}
